import React from 'react'
import { Controller } from 'react-hook-form'
import SimpleInput from './SimpleInput'

const SimpleInputController = ({
	control,
	name,
	inputLabel,
	isLabel = true,
	inputPlaceholder,
	styleMode,
	onChange: customOnChange,
	rules = {},
}) => {
	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			isLabel={isLabel}
			render={({ field }) => {
				const finalOnChangeHandler = (e) => {
					if (customOnChange) {
						customOnChange(e, field.onChange)
					} else {
						field.onChange(e)
					}
				}

				return (
					<SimpleInput
						inputLabel={inputLabel}
						isLabel={isLabel}
						inputPlaceholder={inputPlaceholder}
						inputVariable={field.value}
						styleMode={styleMode}
						onChange={finalOnChangeHandler}></SimpleInput>
				)
			}}></Controller>
	)
}

export default SimpleInputController
